module.exports = __webpack_public_path__ + "media/images/home/home-about-3f8cf511644c659093709c8a75d0a74c.png";